import { analyticsIds } from '../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../constants/cypressIds';
import { JobProfilePage } from '../../../../../constants/duskIds';
import { inAppText } from '../../../../../constants/inAppText';
import { getValidationObject } from '../../../../../constants/regexPatterns';

export const requiredInfoStack = [
  {
    name: 'insuredCompanyName',
    label: 'Insured Company Name',
    placeholder: 'Insured Company Name',
    required: true,
    validationRules: {
      required: {
        value: true,
        message: 'Insured Company Name is a required field'
      },
      minLength: {
        value: 3,
        message: 'Insured Company Name must have at least three characters'
      },
      maxLength: {
        value: 200,
        message: 'Insured Company Name must have fewer than 200 characters'
      }
    },
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.companyNameInput,
    dusk: JobProfilePage.insuredCompanyNameInput,
    cypressId: CypressIds.createRecordTrayInsuredNameInput
  },
  {
    name: 'insuredEmail',
    label: 'Primary Contact Email',
    placeholder: 'example@email.com',
    required: true,
    validationRules: {
      required: {
        value: true,
        message: 'Insured Contact Email is a required field'
      },
      ...getValidationObject('emailAddress')
    },
    toolTip: inAppText.tooltips.insureds.newInsured.primaryContactEmail,
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.primaryContactEmailInput,
    dusk: JobProfilePage.insuredPrimaryEmailInput,
    cypressId: CypressIds.createRecordTrayInsuredEmailInput
  },
  {
    name: 'insuredCc',
    label: 'Secondary Contact Emails',
    placeholder: 'example.one@email.com, example.two@email.com',
    validationRules: getValidationObject('commaSeparatedEmailAddress'),
    toolTip: inAppText.tooltips.insureds.newInsured.secondaryContactEmails,
    caption: 'Comma separated',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.secondaryContactEmailInput
  }
];

export const insuredContactStack = [
  {
    name: 'insuredAdress',
    label: 'Address',
    width: '100%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.addressInput
  },
  {
    name: 'insuredCity',
    label: 'City',
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.cityInput
  },
  {
    name: 'insuredState',
    label: 'State',
    validationRules: {
      maxLength: 2,
      message: 'State\'s 2-letter abbreviation'
    },
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.stateInput
  },
  {
    name: 'insuredZip',
    label: 'Postal Code',
    validationRules: getValidationObject('digits'),
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.postalCodeInput
  },
  {
    name: 'country',
    label: 'Country',
    validationRules: {
      minLength: 2,
      maxLength: 2,
      message: 'Country\'s 2-letter abbreviation'
    },
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.countryInput
  },
  {
    name: 'insuredPhone',
    label: 'Primary Phone',
    type: 'phoneNumber',
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.primaryPhoneInput
  },
  {
    name: 'insuredPhone2',
    label: 'Secondary Phone',
    type: 'phoneNumber',
    width: '50%',
    dataAnalyticsId: analyticsIds.insuredsListPage.createInsuredForm.secondaryPhoneInput
  }
];
